<template>
    <div>
        <navBar></navBar>
        <div class="main">
            <div class="content">
                <p class="title">《商业贸促会数据平台隐私政策》</p>
            </div>
            <div class="content">
                <p>“商业贸促会数据平台”是指「中国国际贸易促进委员会商业行业委员会（以下简称我们）及其关联公司合法拥有并运营的，标注名称为商业贸促会数据平台的官方网站。</p>
            </div>
            <div class="content">
                <p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息;权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
                    请在使用我们的服务前，仔细阅读并了解本《商业贸促会数据平台隐私政策》。
                </p>
            </div>
            <div class="content">
                <p>●我们会遵循《隐私政策》收集、使用您的信息，但不会仅因您同意本《隐私政策》而采用强制捆绑的方式一揽子收集个人信息。<br />
                    ●当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明哪些是必要信息。<br />
                    ●精确地理位置、摄像头、麦克风、相册权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。
                </p>
            </div>
            <div class="content">
                本《隐私政策》适用于您通过商业贸促会数据平台官方网站方式来访问和使用我们的产品和服务。
            </div>
            <div class="content">
                本政策将帮助您了解以下内容:<br />
                1.我们如何收集和使用个人信息<br />
                2.我们如何保护个人信息的安全<br />
                3.您的权利和管理您的个人信息<br />
                4.我们如何处理未成年人的个人信息<br />
                5.我们如何使用Cookie等同类技术<br />
                6.我们如何存储个人信息<br />
                7.本《隐私政策》如何更新<br />
                8.如何联系我们<br />
            </div>
            <div class="content">
                <p>相关术语及定义:<br />
                    1.
                    个人信息:指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本政策中涉及的个人信息包括:1.基本信息(包括个人姓名、生日、性别、民族、国籍、家庭关系、住址、个人电话号码、电子邮件地址等);个人身份信息(包括身份证、军官证、护照、驾驶证、工作证、出入证、社保卡、居住证等);网络身份标识信息(包括个人信息主体账号、IP地址、个人数字证书等);个人教育工作信息(包括个人职业、职位、工作单位、学历、学位、教育经历、工作经历、培训记录、成绩单等)。<br />参考自:GB/T35273--2020《信息安全技术个人信息安全规范》
                </p>
                <p>2.个人敏感信息:指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息包括个人身份信息、个人生物识别信息、银行账号、财产信息(积分、兑换、交易和消费记录以及余额等虚拟财产信息)、行为轨迹、交易信息、14岁以下(含)儿童信息的个人信息。相比其他个人信息，个人敏感信息可能对您的个人权益影响更大。我们在此善意的提醒您需在谨慎考虑后再向我们提供您的个人敏感信息。
                    参考自:GB/T35273--2020《信息安全技术个人信息安全规范》
                </p>
                <p>3.Cookie:Cookie是网页服务器放在您访问设备上的文本文件可能是
                    Cookie，FlashCookie，或您的浏览器或关联应用程序提供的其他本地存储(统称为Cookie，会帮助您在后续访问时调用信息，简化记录您填写个人信息的流程。您有权接受或拒绝Cookie，如果浏览器自动接收
                    Cookie，您可以根据自己的需要修改浏览器的设置以拒绝Cookie。请注意，如果您选择拒绝Cookie，那么您可能无法完全体验商业贸促会数据平台提供的服务。</p>
                <p>请您在向我们提交个人信息之前，充分阅读、了解并同意本政策和任何补充政策。您使用或继续使用我们服务，即意味着您同意我们按照本政策收集、使用、存储和共享您的相关信息。如对本政策或相关事宜有任何问题，您可通过官网与我们联系。当本指引发生实质变更时，我们会在版本更新后以推送短信通知等形式向您展示变更后的内容。
                </p>
                <p>1.我们如何收集和使用个人信息<br />
                    个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括:基本信息、个人身份信息、网络身份标识信息、个人教育工作信息、联系人信息。
                </p>
                <p>个人敏感信息是指一旦泄露，非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息包括:个人身份信息、个人生物识别信息、银行账号、财产信息(积分、兑换、交易和消费记录以及余额等虚拟财产信息)、行为轨迹、交易信息、14岁以下(含)儿童信息的个人信息。我们仅会出于以下目的，收集和使用您的个人信息:您须授权我们收集和使用您个人信息的情形。
                </p>
                <p>我们的服务包括一些核心功能，这些功能包含了实现服务所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。在您提供相关信息后，您将享受我们提供的服务。我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息:
                </p>
                <p>1.1注册、登录、认证<br />
                    1.1.1注册、登录帐号<br />
                    当您注册登录商业贸促会数据平台及相关服务时，您可以通过手机号创建帐号，并且您可以完善相关的网络身份识别信息(头像、昵称、密码等)，收集这些信息是为了帮助您完成注册。收集手机号码是履行国家法律法规关于网络实名制(真实身份信息认证)要求的必要信息，如果您拒绝提供手机号码用于注册、登录，我们可能无法为您提供信息发布功能。<br />
                    1.1.2认证<br />
                    在您使用身份认证的功能或相关服务所需时，根据相关法律法规及监管要求，确保用户身份真实性，您可能需要提供您的真实身份信息(真实姓名、手机号码)以完成实名验证。部分信息属于个人敏感信息，您可以拒绝提供，如果拒绝提供您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。
                </p>
                <p>1.2发布与互动<br />
                    1.2.1信息发布<br />
                    您修改头像时，我们会请求您授权相机、照片权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用商业贸促会数据平台的其他功能。<br />
                    1.2.2消息通知<br />
                    您知悉并同意，对于您在使用产品及或服务的过程中提供的您的联系方式(例如:联系电话)，我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等用途;此外，我们也可能会以短信、电话的方式，为您提供您可能感兴趣的服务、功能或活动等商业性信息的用途，但请您放心，如您不愿接受这些信息,可以直接与我们联系进行退订。
                </p>
                <p>1.3运营与安全保障<br />
                    我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。
                </p>
                <p>1.4分享与活动参与<br />
                    在您分享或接收被分享的信息、参加活动等情形下，我们需要访问您的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。
                </p>
                <p>1.5收集、使用个人信息目的变更<br />
                    请您了解，随着我们业务的发展，可能会对商业贸促会数据平台的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。
                </p>
                <p>1.6您可自主选择提供的个人信息的情形<br />
                    基于相机/摄像头或相册(相片库/视频库)的扩展功能:在您开启相机/摄像头权限后，使用该功能拍摄照片/视频或直接上传您相片库/视频库的图片/视频，以实现更换头像上传。我们可能会通过您上传的图片/视频进行活动评选、违规处理以及涉及其他纠纷(包括但不限于知识产权)的依据等。
                </p>
                <p>上述扩展功能可能需要您在您的设备中向我们开启您的相机(摄像头)、相册(图片库)、本地存储的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在手机设置--权限管理中更改状态(各厂商机型设置路径可能存在不一致，您可参考厂商设置说明)，逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
                </p>
                <p>1.7个人信息的使用<br />
                    1.7.1 依法豁免征得同意收集和使用的个人信息<br />
                    <span class="weight">
                        请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意:
                    </span>
                </p>
                <p>a为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需;</p>
                <p>b.为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、公共安全、公共卫生、重大公共利益、犯罪侦查、起诉、审判和判决执行直接相关的法定义务履行所必需;</p>
                <p>c.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需;d.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息;</p>
                <p>d依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息;</p>
                <p>e法律、行政法规规定的其他情形。<br />
                    特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息;当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。
                </p>
                <p>1.7.2您个人信息使用的规则<br />
                    <span class="weight">
                        我们会根据本《隐私政策》的约定并为实现我们的服务功能对所收集的个人信息进行使用。请您注意，您在使用我们的服务时所提供的所有个人信息，除非您联系我们拒绝收集，否则将在您使用我们服务期间持续授权我们使用。
                    </span>
                </p>
                <p>2我们如何保护个人信息的安全<br />
                    a.我们非常重视您个人信息的安全，将努力采取合理的安全措施(包括技术方面和管理方面)来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。<br />
                    b 我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。<br />
                    c.我们会建立专门的安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。<br />
                    d.
                    <span class="span weight">
                        尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。
                    </span><br />
                    e.您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码不将自己的帐号密码及相关个人信息透露给他人等。<br />
                    f.我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一日发生用户信息安全事件(泄露、丢失)后，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响
                    我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。<br />
                    g.
                    <span class="span weight">
                        您一旦离开商业贸促会数据平台及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在商业贸促会数据平台及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于商业贸促会数据平台的链接或引导。
                    </span>
                </p>
                <p>3您的权利和管理您的个人信息<br />
                    我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的查询、访问、修改、删除、撤回同意授权、注销帐号、投诉举报以及设置隐私功能的相关权利，以使您有能力保障您的隐私和信息安全<br />
                    3.1投诉举报<br />
                    如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以与我们联系。我们核查后会在15个工作日内反馈您的投诉与举报。

                </p>
                <p>4我们如何处理未成年人的个人信息<br />
                    4.1未成年人通用条款<br />
                    a.若您是未满18周岁的未成年人，在使用商业贸促会数据平台及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策<br />
                    b.我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息;如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。<br />
                    c.若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。
                </p>
                <p>5我们如何使用Cookie等同类技术<br />
                    Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用商业贸促会数据平台及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务:<br />
                    5.1保障产品与服务的安全、高效运转
                </p>
                <p>我们可能会设置认证与保障安全性商业贸促会数据平台或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。<br />
                    5.2帮助您获得更轻松的访问体验<br />
                    使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程(示例:记录搜索、表单填写)。<br />
                    5.3 Cookie的清除<br />
                    大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。
                </p>
                <p>6我们如何存储个人信息<br />
                    6.1存储地点<br />
                    我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。<br />
                    6.2存储期限<br />
                    我们仅在为提供商业贸促会数据平台及服务之目的所必需的期间内保留您的个人信息。
                </p>
                <p>7本《隐私政策》如何更新<br />
                    a为了给您提供更好的服务，商业贸促会数据平台及相关服务将不时更新与变化。我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。<br />
                    b 本政策更新后，我们会在商业贸促会数据平台发出更新版本，并在更新后的条款生效前通过官方网站公告或其他适当的方式提醒您更新的内容，以便您及时了解本政策的最新版本。
                </p>
                <p>8 如何联系我们<br />
                    官方网站http://www.ccpitcsc.org/
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import navBar from "@/components/navBar.vue";
export default {
    components: {
        navBar,
    },
    data() {
        return {

        };
    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.main {
    margin-top: 50px;
    text-align: left;
    font-family: "SimSun", serif;
    padding: 10px 15px 50px;
    line-height: 1.5;
    letter-spacing: 1px;

    .weight {
        font-weight: bold;
    }

    .title {
        text-align: center;
        // font-size: 24px;
        margin-bottom: 10px;
    }

    .time {
        text-align: right;
        font-size: 12px;

        .line {
            border-bottom: 1px solid #000;
            padding-left: 20px;
            padding-right: 3px;
        }
    }

    .content {
        font-size: 14px;
        margin-top: 10px;

        p {
            margin-top: 5px;
        }
    }
}
</style>